import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson7: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] mix-blend-normal text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson6"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-end justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">
            Blockchain Explained
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson8"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[9.63rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">

        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>{`What Is Bitcoin & Where Has it Come From?`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                According to Bitcoins Whitepaper, it can be defined as a
                “peer-to-peer electronic cash system.”
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The Bitcoin white paper was the first document to lay forth the
                fundamentals of a cryptographically secure trustless
                peer-to-peer (P2P) electronic payment system fundamentally
                designed to be censorship-resistant and transparent, all while
                reclaiming financial power for individuals.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                During the "Sub Prime" era (economic crisis in 2008), a person
                nicknamed Satoshi Nakamoto released the official whitepaper
                defining the Bitcoin idea and the first ever digitalized
                decentralized currency. It is considered to be a "truly scarce"
                resource because of the parameters set in the whitepaper stating
                there can only be 21 Million Bitcoin Supply in circulation.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The name "Satoshi Nakamoto" is believed to be a pseudonym and
                the true identity of the Bitcoin inventor remains to be unknown
                even today. Many people have claimed to be Satoshi Nakamoto,
                none of which have any concrete evidence.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                At the time of it's creation and a few years after, Bitcoin had
                little to no monetary value. However it's strong and active
                communities of people helped to continuously improve the
                original code despite Satoshi leaving the development of
                Bitcoin. The last known communication with him was from an email
                in April 2011.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Bitcoin today is much more transferable and easily stored
                compared to a resource like gold. If you want to move gold,
                it’ll cost a lot of money (transport/storage/etc). Bitcoin can
                even be stored on a USB stick — referred to as cold or hard
                wallets.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Why was Bitcoin Created?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                If we take a look back during the 1900s, physical valuables such
                as gold and silver were traded for commodities and services.
                Because these physical assets were such a pain to actually carry
                and were prone to loss and theft, banks retained them for users.
                In doing so the banks, produced notes confirming users’ bank
                holdings.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Users became extremely reliant on banks to maintain the value of
                their currency and protect their assets. During the global
                economic crisis of 2008-09, several banks and other major
                financial organizations failed and governments were forced to
                bail them out at taxpayers' expense.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The failure of banks (as the holders of public funds) showcased
                how truly fragile the modern financial system could be. This
                crisis rocked global economies and the need to decentralize the
                financial services was at an all time high. Bitcoin was seen as
                a response to the Great Financial Crisis and the global reliance
                on banks as financial transaction intermediaries.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Satoshi Nakamoto had the vision of removing banks from financial
                transactions and replacing them with a peer-to-peer (P2P)
                payment system that didn't require third-party confirmation,
                eliminating the need for banks to be facilitating every
                transaction. The blockchain a network-based ledger, enabled
                Bitcoin and other cryptocurrencies to develop this trust.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Additional Bitcoin Creation Facts:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  The first block, widely known as the "genesis block", was
                  mined on Jan. 3, 2009.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Bitcoin had no monetary worth in the first few months of its
                  existence
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Miners that discovered new bitcoin exchanged it for fun
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  First economic transaction was almost a year after it's
                  creation.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Laszlo Hanyecz, **a Florida man **agreed to have $25 pizza
                  delivered for 10,000 Bitcoins on May 22, 2010. (That would be
                  worth roughly $563 Million today)
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  He is the first person to use bitcoin commercially in a
                  transaction
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>Day is known as Bitcoin Pizza Day</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How Does Bitcoin Work?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Unlike traditional currencies, Bitcoin is issued neither by a
                central bank nor backed by a central government. As a result,
                traditional financial market indicators like inflation rates,
                monetary policy and economic growth that usually influence
                currency values does not apply to Bitcoin.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Bitcoin is based on the blockchain which can be simply defined
                as distributed digital ledger.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <a
              className="text-[inherit]"
              href="/8fcb12d2e6e0406b9148a429ae22e73b"
              target="_blank"
            >
              <b>
                <span className="[text-decoration:underline]">
                  Refer to our Blockchain Guide
                </span>
              </b>
            </a>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                To be included in the Bitcoin blockchain, a transaction block
                must be validated by the majority of Bitcoin miners. The
                statistical randomness for each transaction on greatly reduces
                the likelihood of a fraudulent Bitcoin transaction made by
                anyone connected to the network.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[84.31rem] h-[28.32rem] object-cover"
          alt=""
          src="/i30@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Bitcoin Public And Private Keys</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When you own any form of cryptocurrency, what you really own is
                a “private key.” Your “private key” gives you the right to spend
                the associated cryptocurrencies.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Private keys are made up of random sequences of letters and
                numbers. Private keys themselves are almost never handled by the
                user. Instead you are typically given a unique seed phrase
                (random words) that encodes the same information as private
                keys. Private keys should always be kept confidential, just as
                passwords for email or other services.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                There is also a public key that has a cryptographic link to your
                private key. Theoretically you can create as many public keys as
                you would like from your private key. Your private key (a
                password) allows Bitcoin/cryptocurrencies to be sent elsewhere
                once sent to the public key (Bitcoin address).
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Bitcoin addresses (public keys) are also randomly generated
                sequences of letters and numbers. They are public so that you
                can safely share them with others when you want to send and
                receive bitcoin/cryptocurrencies.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Advantages of Bitcoin</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>{`Anonymous & Private`}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Non-Inflationary</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Low/Minimal Fees</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Fast & Secure Transactions`}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Lower Fraud Risk</span>
              </span>
            </li>
            <li>
              <span>
                <span>Personal Information is encrypted and safe</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Disadvantages:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Level Of Acceptance In Modern Society</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Extreme Volatility</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Government Intervention (Banning usage in countries)
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Deflationary (Limited Supply, Less Circulation)</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Irreversibility Of Transactions (Theft, Hackers, Loss of
                  Wallets)
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>No Valuation Guarantee</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson8">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson7;
